<section class="content">
  <div class="row" *ngIf="(profileState | async).profileDetail !== null">
    <div class="col-md-8">
      <h6 class="content-header">Profile</h6>
      <div class="spinner" *ngIf="!(profileState | async).loader['audit']['detail']"></div>
      <div class="card" [ngClass]="!(profileState | async).loader['audit']['detail'] ? 'background-loader' : ''">
        <div class="card-body profile-info">
          <div class="row">
            <div class="col-md-4">
              <div class="text-center">
                <a class="avatar-content" href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank" >
                  <img class="avatar" default="./assets/images/user-avatar.png" [src]="(profileState | async).profileDetail.profile_pic_url" alt="Audited profile avatar" style="width: 170px; height: 170px; border-radius: 50%"/>
                  <img class="icon-platform" src="assets/images/icons/instagram-2.png"/>
                </a>
              </div>
            </div>
            <div class="col-md-8 profile-details">
              <h1 class="profile-name">
                <a href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank">
                  &#64;{{(profileState | async).profileDetail.username}}</a>
              </h1>
              <p class="profile-description">{{(profileState | async).profileDetail.full_name}}</p>
              <p class="profile-description" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status == 2">
                Generated on {{(profileState | async).audit.added_time * 1000 | date}}
              </p>

              <div class="report-results">
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.media_count | shortcutNumbers}}</h2>
                  <p class="sub-text">Posts</p>
                </div>
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.followed_by | shortcutNumbers}}</h2>
                  <p class="sub-text">Followers</p>
                </div>
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.follows | shortcutNumbers}}</h2>
                  <p class="sub-text">Followed</p>
                </div>
              </div>
            </div>
          </div>
          <app-demo-add type="1"></app-demo-add>

        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h6 class="content-header">
        SocialAuditor score
        <a data-tooltip="SocialAuditor Score takes into account: no. of suspicious followers, mass followers, love factor, quality likes, quality comments, true ER, real, unique and engaged users">
          <img class="icon-info" src="./assets/images/icons/info.png" />
        </a>
      </h6>
      <div class="card quality-info">
        <div class="card-body">
          <app-progress type="like"></app-progress>
          <div>
            <div class="spinner" *ngIf="!(profileState | async).loader['audit']['engageIndicator']"></div>
            <div class="quality-score">
              <h2 *ngIf="(profileState | async) !== undefined && (profileState | async).score !== null">
              <span *ngIf="(profileState | async).audit.status === 1">
                Loading...
              </span>
                <span *ngIf="(profileState | async).audit.status === 2">
                {{(profileState | async).score.score}}/100
                <span *ngIf="(profileState | async).score.score > 75">😀</span>
                <span *ngIf="(profileState | async).score.score < 75 && (profileState | async).score.score > 50">🙂</span>
                <span *ngIf="(profileState | async).score.score < 50 && (profileState | async).score.score > 25">🙁</span>
                <span *ngIf="(profileState | async).score.score < 25">☹️</span>
              </span>
                <div *ngIf="(profileState | async).audit.status === 0">
                  <app-price-popup [type]="1"></app-price-popup>
                </div>


              </h2>
              <div class="value" *ngIf="(profileState | async) !== undefined && (profileState | async).score !== null">
                <a *ngIf="(profileState | async).audit.status === 0">
                  <app-price-popup [type]="2"></app-price-popup>
                </a>
                <span
                  class="bar"
                  *ngIf="(profileState | async).audit.status === 2"
                  [ngStyle]="{width: (profileState | async).score.score + '%'}"
                  [ngClass]="{'green': (profileState | async).score.score < 80, 'orange': (profileState | async).score.score < 60, 'red': (profileState | async).score.score < 40 }"
                ></span>
              </div>
            </div>
            <div class="report-results mt-0">
              <div class="b-left">
                <app-audit-no-mention type="value">
                  <h2 *ngIf="((profileState | async).audit !== null) && (profileState | async).followerEngage !== null">
                    {{(profileState | async).followerEngage.engage_count | number:'1.2'}}%
                  </h2>
                </app-audit-no-mention>
                <p class="sub-text">
                  ER
                  <a data-tooltip="Percent of followers who liked or commented the post (last 30 days)">
                    <img class="icon-info" src="./assets/images/icons/info.png"/>
                  </a>
                </p>
              </div>
              <div class="b-left">
                <app-audit-no-mention type="value">
                  <h2 *ngIf="((profileState | async).audit !== null) && ((profileState | async).audit.status) && engagementIndicator !== undefined">
                    {{engagementIndicator.trueFollowerEr}}%
                  </h2>
                </app-audit-no-mention>
                <h2 *ngIf="!((profileState | async).audit.status)">
                  <app-price-popup [type]="2"></app-price-popup>
                </h2>
                <p class="sub-text">
                  tER
                  <a data-tooltip="Comments and likes from real users (without mass followers or bots)">
                    <img class="icon-info" src="./assets/images/icons/info.png"/>
                  </a>
                </p>
              </div>
              <div class="b-left">
                <app-audit-no-mention type="value">
                  <h2 *ngIf="((profileState | async).audit.status) && engagementIndicator !== undefined">
                    {{(0.83 * engagementIndicator.trueFollowerUniqueInteraction) | shortcutNumbers}}
                  </h2>
                </app-audit-no-mention>
                <h2 *ngIf="!((profileState | async).audit.status)">
                  <app-price-popup [type]="2"></app-price-popup>
                </h2>
                <p class="sub-text">
                  LF
                  <a data-tooltip="No. of users who regularly engage with the content">
                    <img class="icon-info" src="./assets/images/icons/info.png"/>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="card" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1 && (profileState | async).profileProgress.data.percent !== 33">
    <div class="card-body-placeholder">
      <h3>The report is under preparation. Data are being collected.</h3>
      <p>This can take up to 10 hours. We are analyzing your posts, likes and dislikes and your audience in real time.</p>
      <!--    <p>Each box shows the current progress so that you know how much data is being analyzed until now.</p>-->
      <div class="report-loader my-5" *ngIf="(profileState | async).profileProgress.data.percent !== 0">
        <div class="progress"
             [ngStyle]="{width: ((profileState | async).profileProgress.data !== undefined ? (profileState | async).profileProgress.data.percent : 0) + '%'}">
        </div>
        <div
          *ngIf="(profileState | async).profileProgress.data.percent !== 0"
          class="value-bubble"
          [ngStyle]="{left: 'calc(' + ((profileState | async).profileProgress.data !== undefined ? (profileState | async).profileProgress.data.percent : 0) + '% - 75px)'}">
          <h2 class="text-cyan">{{(profileState | async).profileProgress.data !== undefined ? (profileState | async).profileProgress.data.percent : 0}}%</h2>
          <span>done</span>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="content">
  <div class="card" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1 && (profileState | async).audit.bio.mention_count !== undefined && (profileState | async).audit.bio.mention_count === 0">
    <div class="card-body-placeholder p-5">
      <h3>Audited user did not add a post within last 30 days.</h3>
      <p>Report contains only audience data. Posts are not included.</p>
    </div>
  </div>
</section>


<section class="content">
  <div class="card" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 0 && (profileState | async).profileProgress !== null && (profileState | async).profileProgress.media.percent < 100">
    <div class="card-body-placeholder">
      <h3>The report is under preparation. Data are being collected.</h3>
      <p>We analyze posts in real time and it may take a minute.</p>
      <p>Current progress is <span class="text-cyan font-weight-bold">{{trialPercent}}%</span></p>
      <!--    <div class="video-wrapper mt-5">-->
      <!--      <iframe width="720" height="405" src="https://www.youtube.com/embed/ym8SvFkenYs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
      <!--    </div>-->
    </div>
  </div>
</section>


<section class="content" *ngIf="id === undefined || ((profileState | async).audit !== null && (profileState | async).audit.status > 0)">
  <app-followers-reliability type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-reliability>
  <app-interaction-analyze type="1" class="w-100" [auditType]="type()" [id]="id"></app-interaction-analyze>
  <app-followers-demography type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-demography>
  <app-followers-location type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-location>
  <app-profile-analyze class="w-100" [auditType]="type()" [id]="id"></app-profile-analyze>
  <app-user-rank [auditType]="type()" [id]="id"></app-user-rank>
</section>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h3 class="card-header">
            Engagement rate by days
            <a data-tooltip="Average engagement rate - checked per day (graph showing dynamics in the last 30 days)">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </h3>
        </div>
        <app-audit-no-mention type="chart" name="Engagement rate">
          <div class="spinner" *ngIf="!(profileState | async).loader['audit']['followerEngage']"></div>
          <div
            class="col-12 m-portlet__body box-md"
            [ngClass]="!(profileState | async).loader['audit']['followerEngage'] ? 'background-loader' : ''">
            <div class="m--margin-top-20" *ngIf="chartsFollowerEngage !== undefined">
              <div [chart]="chartsFollowerEngage[0]"></div>
            </div>
          </div>
        </app-audit-no-mention>

      </div>
    </div>
  </div>
</section>


<section class="content">
  <div class="card" *ngIf="interactionAvg !== undefined && (profileState | async).audit !== null && (profileState | async).audit.status !== 0">
    <div class="row card-body">
      <div class="col-md-8">
        <h3 class="card-header">
          Engagement
          <a data-tooltip="Average engagement of the audited profile - number of interactions versus number of followers">
            <img class="icon-info" src="./assets/images/icons/info.png" />
          </a>
        </h3>
        <p class="text-medium">Compared to average values for similar accounts (by numbers of followers)</p>
      </div>
      <div class="col-md-2 mt-sm-3">
        <app-audit-no-mention type="value">
          <h2><span *ngIf="(profileState | async).followerEngage !== null">{{(profileState | async).followerEngage.like_avg | separateNumbers}}</span></h2>
        </app-audit-no-mention>
        <p class="sub-text mt-1">
          Avg likes
          <a data-tooltip="Average number of likes per post">
            <img class="icon-info" src="./assets/images/icons/info.png" />
          </a>
        </p>
      </div>
      <div class="col-md-2 mt-sm-3">
        <app-audit-no-mention type="value">
          <h2><span  *ngIf="(profileState | async).followerEngage !== null">{{(profileState | async).followerEngage.comment_avg | separateNumbers}}</span></h2>
        </app-audit-no-mention>
        <p class="sub-text mt-1">
          Avg comments
          <a data-tooltip="Average number of comments per post">
            <img class="icon-info" src="./assets/images/icons/info.png" />
          </a>
        </p>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <h6 class="content-header">
        Average engagement rate table
        <a data-tooltip="Table presenting ranges of followers and average engagement">
          <img class="icon-info" src="./assets/images/icons/info.png"/>
        </a>
      </h6>
      <div class="card">
        <div class="spinner" *ngIf="!(profileState | async).loader['audit']['followerEngage']"></div>
        <div class="card-body"
             [ngClass]="!(profileState | async).loader['audit']['followerEngage'] ? 'background-loader' : ''"
        >
          <app-audit-no-mention type="chart" name="Average engagement rate table">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>No. of followers</th>
                  <th>
                    Avg engage
                    <a data-tooltip="Average percent of engagement">
                      <img class="icon-info" src="./assets/images/icons/info.png"/>
                    </a>
                  </th>
                  <th>
                    Profile engage
                    <a data-tooltip="Engagement of an audited profile as compared to others">
                      <img class="icon-info" src="./assets/images/icons/info.png" />
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let engage of engagementStat" [ngClass]="{'bg' : engage.profile !== undefined }">
                  <td>{{engage.description}}</td>
                  <td>{{engage.engage}}%</td>
                  <td class="profile-engage">
                  <span *ngIf="engage.profile !== undefined">
                    <img
                      [src]="(profileState | async).profileDetail.profile_pic_url"
                      *ngIf="(profileState | async).profileDetail !== null"
                      class="avatar"
                    />
                    <span class="results" *ngIf="engage.profile.engage > 0">
                      {{engage.profile.engage | number:'1.2'}}%
                      <span class="text-green" *ngIf="engage.profile !== undefined && engage.profile.engage > engage.engage">
                        <img class="direction-icon" src="./assets/images/icons/up.png" />
                        Result above average
                          <a data-tooltip="Great! The average result for similar accounts is lower">
                            <img class="icon-info" src="./assets/images/icons/info.png" />
                          </a>
                      </span>
                      <span class="text-red" *ngIf="engage.profile !== undefined && engage.profile.engage < engage.engage">
                        <img class="direction-icon" src="./assets/images/icons/down.png" />
                        Result below average
                          <a data-tooltip="Ooops! The average result for similar accounts is higher">
                            <img class="icon-info" src="./assets/images/icons/info.png" />
                          </a>
                      </span>
                    </span>
                    <span *ngIf="engage.profile.engage == 0">
                      Loading data ...
                    </span>
                  </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </app-audit-no-mention>

        </div>
      </div>
    </div>
  </div>

</section>



<section class="content" *ngIf="((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
  <app-followers-reliability type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-reliability>

  <app-user-rank [auditType]="type()" [id]="id"></app-user-rank>

  <app-interaction-analyze type="1" class="w-100" [auditType]="type()" [id]="id"></app-interaction-analyze>

  <app-profile-analyze class="w-100" [auditType]="type()" [id]="id"></app-profile-analyze>

  <app-followers-demography type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-demography>

  <!--    <app-comment-time class="w-100"></app-comment-time>-->

  <div [ngClass]="!((profileState | async).audit !== null && (profileState | async).audit.status) ? 'm--margin-bottom-100' : ''">
    <app-followers-location type="1" class="w-100" [auditType]="type()" [id]="id"></app-followers-location>
  </div>


</section>
